import { css, html, LitElement } from '~/lib/bn-lit-element';
import { sharedStyles } from '../../styles/shared-styles';

class ImportCsvUploadButton extends LitElement {
  static get properties() {
    return {
      disabled: { type: Boolean },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      .file-input {
        display: none;
      }
    `];
  }

  render() {
    return html`
      <input type="file" class="file-input" accept=".csv" @input="${this._onFileInput}"/>
      <button class="button button--outlined" @click="${this._onUploadButtonClick}" ?disabled="${this.disabled}"><slot></slot></button>
    `;
  }

  _onUploadButtonClick() {
    const fileInput = this.shadowRoot.querySelector('.file-input');
    fileInput.value = null; // this makes sure the same file can be re-uploaded
    fileInput.click();
  }

  async _onFileInput(e) {
    const file = e.target.files[0];
    this.dispatchEvent(new CustomEvent('file-selected', { detail: { file } }));
  }
}

window.customElements.define('import-csv-upload-button', ImportCsvUploadButton);
